/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EPersonFinancialPaymentMethod } from "../types/EPersonFinancialPaymentMethod.ts";

/**
 * @description 1 = Colleger | 2 = Refound | 3 = CheckingAccountPayment | 4 = SavingAccountPayment | 5 = Check |
 */
export const ePersonFinancialPaymentMethodSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(5)])
  .describe(
    "1 = Colleger | 2 = Refound | 3 = CheckingAccountPayment | 4 = SavingAccountPayment | 5 = Check | ",
  ) as unknown as ToZod<EPersonFinancialPaymentMethod>;
